import z from "zod";

// The scope literals mirror PERMISSION_SCOPES in @msuite/citadel. utils cannot import citadel —
// citadel already depends on this package — so the handler re-validates every entry against the
// canonical scope map and refuses loudly if the two ever drift.
const scopeSchema = z.enum(["organization", "own", "ownProjects"]);

/**
 * The individual permission grid's payload: one entry per `action:subject` cell, `false` for
 * revoked, otherwise the chosen scope — the same shape the role editor sends, because since the
 * scopes arrived there the two grids describe the same thing. The delete on the write path is
 * scoped to the named pairs, so a pair the form withholds stays untouched.
 */
export const userPermissionFormSchema = z.object({
	permissions: z.record(z.string(), z.union([z.literal(false), scopeSchema])),
});

export type UserPermissionFormSchema = z.infer<typeof userPermissionFormSchema>;
